<template>
  <div class="errors-block">
    <div v-if="v?.$dirty && v?.required === false" class="errors-block-msg">
      <p>{{fieldName}} is required</p>
    </div>
    <div v-else-if="v?.$dirty && v?.minMaxLength === false" class="errors-block-msg">
      <p>{{fieldName}} must be {{v?.$params?.minMaxLength?.min}}-{{v?.$params?.minMaxLength?.max}} characters long</p>
    </div>
    <div v-else-if="v?.$dirty && v?.minLength === false" class="errors-block-msg">
      <p>{{fieldName}} must be at least {{v?.$params?.minLength?.min}} characters long</p>
    </div>
    <div v-else-if="v?.$dirty && v?.maxLength === false" class="errors-block-msg">
      <p>{{fieldName}} must be maximum {{v?.$params?.maxLength?.max}} characters long</p>
    </div>
    <div v-else-if="v?.$dirty && v?.isValidUrl === false" class="errors-block-msg">
      <p>{{fieldName}} must be a valid link</p>
    </div>
    <div v-else-if="v?.$dirty && v?.isEmailValid === false" class="errors-block-msg">
      <p>{{fieldName}} must be a valid email</p>
    </div>
    <div v-else-if="v?.$dirty && v?.isMatchPass === false" class="errors-block-msg">
      <p>{{fieldName}} fwefewfwefewl</p>
    </div>
    <div v-else-if="v?.$dirty && v?.isMatchesPass === false" class="errors-block-msg">
      <p>Passwords do not match</p>
    </div>
    <div v-else-if="v?.$dirty && v?.isCouponCodeValid === false" class="errors-block-msg">
      <p>{{fieldName}} must be a valid coupon code(only numbers and latin characters)</p>
    </div>
    <div v-else-if="v?.$dirty && v?.email === false" class="errors-block-msg">
      <p>{{fieldName}} must be a valid email</p>
    </div>
    <div v-else-if="v?.$dirty && v?.phoneValidation === false" class="errors-block-msg">
      <p>{{fieldName}} must be a valid phone number</p>
    </div>
    <div v-else-if="v?.$dirty && !!customError" class="errors-block-msg">
      <p>{{customError}}</p>
    </div>
    <div v-if="serverError" class="errors-block-msg">
      <p>{{serverError}}</p>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
export default Vue.extend({
  props: {
    name: {
      type: String,
      default: ""
    },
    serverError: {
      type: String,
      default: ""
    },
    customError: {
      type: String,
      default: ""
    },
    v: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    fieldName() {
      return this.name ? this.name : 'This field'
    }
  },
})
</script>
<style lang="scss" scoped>;
.errors-block {
  &-msg {
    margin-top: 4px;
    p {
      font-family: Roboto, sans-serif;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      color: $color-red;
    }
  }
}
</style>